import R from 'ramda';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import hoistStatic from 'hoist-non-react-statics';
import getDisplayName from 'recompose/getDisplayName';
import { close, open } from './actions';
import * as selectors from './selectors';

const getMapStateToProps = R.memoize(modalName => state => ({
  isOpen: selectors.isOpen(modalName, state),
}));

const getMapDispatchToProps = R.memoize(modalName => ({
  handleOpen: R.partial(open, [modalName]),
  handleClose: R.partial(close, [modalName]),
}));

export default R.curry(({ name }, ComponentToWrap) => {
  const WithModal = props => {
    const { isOpen, handleOpen, handleClose, ...rest } = props;

    return (
      <ComponentToWrap
        {...rest}
        isModalOpen={isOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
    );
  };

  WithModal.propTypes = {
    handleOpen: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
  };

  const connectedComponent = connect(
    getMapStateToProps(name),
    getMapDispatchToProps(name),
  )(WithModal);
  const originalName = getDisplayName(ComponentToWrap);

  connectedComponent.displayName = `withModal(${originalName})`;

  hoistStatic(connectedComponent, ComponentToWrap);

  return connectedComponent;
});
